import { render } from "./PlaceholderImage.vue?vue&type=template&id=6e4f9f2a&scoped=true&ts=true"
import script from "./PlaceholderImage.vue?vue&type=script&lang=ts"
export * from "./PlaceholderImage.vue?vue&type=script&lang=ts"

import "./PlaceholderImage.vue?vue&type=style&index=0&id=6e4f9f2a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4f9f2a"]])

export default __exports__